import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Col, Row, Layout, Menu, Dropdown, Icon, Drawer, Divider } from 'antd';
import userProfile from '../user_profile.jpg';
import * as actions from '../store/actions/auth';

import { useMediaQuery } from 'react-responsive'

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 992 })
  return isDesktop ? children : null
}
const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
  return isTablet ? children : null
}
const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  return isMobile ? children : null
}
const Default = ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: 768 })
  return isNotMobile ? children : null
}

class AppHeader extends React.Component {

  state = { visible: false, placement: 'right' };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  onChange = e => {
    this.setState({
      placement: e.target.value,
    });
  };

  render() {
    const { isAuthenticated } = this.props
    const { Header } = Layout;
    const menu = (
      <Menu>
        { isAuthenticated && 

        <Menu.Item key="3">
          <Link to="/account">
            My account
              </Link>
        </Menu.Item>
        }
        <Menu.Divider />
        { isAuthenticated && 

        <Menu.Item key="4" onClick={this.props.logout}>
          Log out
              </Menu.Item>
        }
  
      </Menu>
    );

    return (
      <div>
        <Desktop>
          <Header style={{ backgroundColor: '#ffffff', height: '65px'}}>
            <Row>
              <Col span={5}>
                <Link to="/">
                  <span style={{ color: '#fa541c', fontSize: '3em', fontWeight: 'bolder' }}>Villaride</span>
                </Link>
              </Col>

              <Col span={9}>
                <Menu
                  theme="light"
                  mode="horizontal"
                  style={{ lineHeight: '64px' }}>
                  {
                    isAuthenticated &&
                    <Menu.Item key="1">
                      <span style={{ fontWeight: 'bold' }}>
                        <Link to="/dashboard">
                          Dashboard
                        </Link>
                      </span>
                    </Menu.Item>
                  }
                  {
                    isAuthenticated &&
                    <Menu.Item key="2">
                      <Link to="/mytrips">
                        <span style={{ fontWeight: 'bold' }}>My Trips</span>
                      </Link>
                    </Menu.Item>
                  }
                  {
                    isAuthenticated != true &&
                    <Menu.Item key="3">
                      <span style={{fontWeight: 'bold'}}>
                        <Link to="/how-it-works"> How it works</Link>
                     </span>
                     </Menu.Item>
                  }
                    <Menu.Item key="4">
                      <span style={{ fontWeight: 'bold' }}>
                        <Link to="/help"> Help </Link>
                      </span>
                    </Menu.Item>
                </Menu>
              </Col>

              <Col span={10} style={{ textAlign: 'right' }}>
                <Link to="/find-ride">
                  <Button type="primary" shape="round" size='large' icon="search" style={{ backgroundColor: '#ff3d00', borderWidth: '0px' }}>Find</Button>
                </Link>
                &nbsp;

                <Link to="/post-trip/">
                  <Button type="primary" shape="round" size='large' icon="plus">Post</Button>
                </Link>
                &nbsp;
                {
                  isAuthenticated != true &&
                  <Link to="/login">
                      <Button shape="round" size='large'>Sign in</Button>
                  </Link>
                }
                
                {isAuthenticated &&
                  <span>
                    <img src={userProfile} style={{ height: '40px', width: '40px' }} alt="logo" />
                    &nbsp;&nbsp;
                    <Dropdown overlay={menu} trigger={['click']}>
                      <a className="ant-dropdown-link" href="#">
                        <Icon style={{ fontSize: '24px', color: "#4c4c4c", fontWeight: "normal" }} type="down" />
                      </a>
                    </Dropdown>
                  </span>
                }

              </Col>

            </Row>

          </Header>
        </Desktop>

        <Tablet>
          <Header style={{ backgroundColor: '#ffffff', height: '65px' }}>
            <Row>
              <Col span={14}>
                <Link to="/">
                  <span style={{ color: '#fa541c', fontSize: '3em', fontWeight: 'bolder' }}>Villaride</span>
                </Link>
              </Col>


              <Col span={10} style={{ textAlign: 'right' }}>
                <Link to="/find-ride">
                  <Button type="primary" shape="circle" icon="search" size="large" style={{ backgroundColor: '#ff3d00', borderWidth: '0px' }} />
                </Link> &nbsp;

                <Link to="/post-trip">
                  <Button type="primary" shape="circle" icon="plus" size="large" />
                </Link> &nbsp;

                <Button type="default" size="large" onClick={this.showDrawer}>
                  <Icon type="menu" />
                </Button>
              </Col>

            </Row>

          </Header>
          <Drawer
            // title="Basic Drawer"
            placement={this.state.placement}
            closable={false}
            onClose={this.onClose}
            visible={this.state.visible}
          >
            {
              isAuthenticated != true &&
              <div>
                <Link to="/login" onClick={this.onClose}>Sign In </Link>
                <Divider />
                <Link to="/how-it-works" onClick={this.onClose}>How it works </Link>
                <Divider />
              </div>
            }
            {
              isAuthenticated &&
              <div>
                {/* <Link to={`/user-profile/${this.props.loggedInUser.pk}`} onClick={this.onClose}>Profile </Link>
                <Divider /> */}
                <Link to="/account" onClick={this.onClose}>My Account </Link>
                <Divider />
                <Link to="/dashboard" onClick={this.onClose}>Dashboard</Link>
                <Divider />
                <Link to="/mytrips" onClick={this.onClose}>My Trips </Link>
                <Divider />
              </div>
            }
            <Link to="/help" onClick={this.onClose}>Help</Link>
            <Divider />
            {
              isAuthenticated &&
              <div>
                <p onClick={this.props.logout}> Logout </p>
                <Divider />
              </div>
            }
          </Drawer>
        </Tablet>

        <Mobile>
          <Header style={{ backgroundColor: '#ffffff', height: '65px', paddingLeft: '20px', paddingRight: '20px'}}>
            <Row>
              <Col span={12}>
                <Link to="/">
                  <span style={{ color: '#fa541c', fontSize: '2em', fontWeight: 'bolder' }}>Villaride</span>
                </Link>
              </Col>


              <Col span={12} style={{ textAlign: 'right' }}>
                <Link to="/find-ride">
                  <Button type="primary" shape="circle" icon="search" size="default" style={{ backgroundColor: '#ff3d00', borderWidth: '0px' }} />
                </Link> &nbsp;

                <Link to="/post-trip">
                  <Button type="primary" shape="circle" icon="plus" size="default" />
                </Link> &nbsp;
                <Button type="default" size="default" onClick={this.showDrawer}>
                  <Icon type="menu" />
                </Button>
              </Col>

            </Row>

          </Header>
          <Drawer
            placement={this.state.placement}
            closable={false}
            onClose={this.onClose}
            visible={this.state.visible}
          >
            {
              isAuthenticated != true &&
              <div>
                <Link to="/login" onClick={this.onClose}>Sign In </Link>
                <Divider />
                <Link to="/how-it-works" onClick={this.onClose}>How it works </Link>
                <Divider />
              </div>
            }
            {
              isAuthenticated &&
              <div>
                {/* <Link to={`/user-profile/${this.props.loggedInUser.pk}`} onClick={this.onClose}>Profile </Link>
                <Divider /> */}
                <Link to="/account" onClick={this.onClose}>My Account </Link>
                <Divider />
                <Link to="/dashboard" onClick={this.onClose}>Dashboard</Link>
                <Divider />
                <Link to="/mytrips" onClick={this.onClose}>My Trips </Link>
                <Divider />
              </div>
            }
            <Link to="/help" onClick={this.onClose}>Help</Link>
            <Divider />
            {
              isAuthenticated &&
              <div>
                <p onClick={this.props.logout}> Logout </p>
                <Divider />
              </div>
            }
          </Drawer>
        </Mobile>
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.token !== null,
    loggedInUser: state.currentUser
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
    logout: () => dispatch(actions.logout()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);
